<template>
  <div class="col-md-12 console_command_history">
    <div class="header">
      <div class="form_select">
        <tree-select
            v-model="filter.status"
            :options="status_list"
            :multiple="false"
            :clearable="true"
            :placeholder="translate('utilities.history.status_title')"
        />
      </div>
      <div class="form_select">
        <tree-select
            v-model="filter.result"
            :options="result_list"
            :multiple="false"
            :clearable="true"
            :placeholder="translate('utilities.history.result_title')"
        />
      </div>
    </div>
    <div class="response_table">
      <div class="spinner" v-if="loading"><scale-loader /></div>
      <p v-else-if="!history_list.length">{{ translate('no_data') }}</p>
      <table v-else>
        <thead>
          <tr>
            <th v-for="column in columns" :key="column" scope="col"
                class="pointer" tabindex="0"
                :class="{ selected: filter_type === column }"
                :aria-sort="filter_type === column ? (filter_asc === 'asc' ? 'descending' : 'ascending') : 'none'"
                @click="change_filter(column)"
                @keydown.enter="change_filter(column)"
                @keydown.space.prevent="change_filter(column)">
              {{ translate('utilities.history.' + column) }}
              <i v-if="filter_type === column" class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in history_list" :key="item.id">
            <td
                v-for="column in columns"
                :key="column"
                :data-label="translate('utilities.history.' + column)"
                :class="{ 'text-left': column === 'route' }"
            >
              <span v-if="column === 'started_at'" v-html="get_date_any_lines(item.started_at, null, 2)" />
              <template v-else-if="column === 'memory_peak_bytes'">{{ item.memory_peak_bytes == null ? '' : item.memory_peak_bytes / 1024 }}</template>
              <template v-else-if="column === 'params'">
                <p v-for="param in JSON.parse(item[column])">{{ param }}</p>
              </template>
              <template v-else>{{ item[column] }}</template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsoleCommandHistory',
  data () {
    return {
      command_history: [],
      filter: {status: null, result: null},
      filter_type: '',
      filter_asc: 'asc',
      loading: true,
      request_id: 0,
      columns: ['route', 'status_title', 'result_title', 'memory_peak_bytes', 'duration_ms', 'params', 'started_at']
    }
  },
  computed: {
    status_list () {
      return [
        {id: 0, label: 'running'},
        {id: 1, label: 'finished'},
        {id: 2, label: 'error'}
      ]
    },
    result_list () {
      return [
        {id: 0, label: 'success'},
        {id: 1, label: 'error'}
      ]
    },
    history_list () {
      return this.command_history.map(item => ({
        ...item,
        params: item.params != null && typeof item.params === 'object' ? JSON.stringify(item.params) : item.params
      })).sort(this.compareNumbers)
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.get_command_history()
      }
    }
  },
  beforeDestroy () {
    this.request_id++
  },
  created () {
    this.get_command_history()
  },
  methods: {
    get_command_history() {
      if (!this.$store.getters.getPermissions.permissionGod) return
      const request_id = ++this.request_id
      const params = {}
      for (const key of ['status', 'result']) {
        if (this.filter[key] != null) params[key] = this.filter[key]
      }
      this.loading = true
      this.$http.v1.getConsoleCommandRuns(params, (response) => {
        if (request_id !== this.request_id) return
        this.command_history = response.data.data ?? response.data
        this.loading = false
      }, () => {
        if (request_id !== this.request_id) return
        this.loading = false
        this.global_notify('danger', this.translate('utilities.load_error'))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.console_command_history{
  height: 100%;
  display: flex;
  flex-direction: column;
  .header{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 20px 10px 10px;
    .form_select{
      width: 250px;
      max-width: 100%;
    }
  }
  .response_table{
    padding-left: 0;
    padding-right: 0;
    th, td{
      font-size: 12px;
      overflow-wrap: anywhere;
      p{
        font-size: 12px;
        margin-bottom: 0;
      }
    }
    .text-left{
      text-align: left;
    }
  }
}
</style>
